var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// import * as Device from "expo-device";
// import * as AuthSession from "expo-auth-session"
// import * as Localization from "expo-localization"
import { createAction, useStorage } from 'master-hook';
import { client } from '../services';
import { restQuery } from '../rest';
import { STORAGE_NAME } from './constants';
import { broadcastTokensUpdated } from './auth-tab-sync';
import { purge } from '../use-app/actions';
import { isArray } from 'lodash';
import { loadI18n } from '../use-i18n/actions';
export var whoAmi = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, setIsAuthenticated, setIsInitialized, setPhotoURL, setDisplayName, setShowInterfaceSettings, setEmail, setId, setRole, setMainCurrency, setPermissions, result, _b, photoURL, displayName, showInterfaceSettings, email, id, role, mainCurrency, _c, permissions, error_1;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = useStorage(STORAGE_NAME), setIsAuthenticated = _a.setIsAuthenticated, setIsInitialized = _a.setIsInitialized, setPhotoURL = _a.setPhotoURL, setDisplayName = _a.setDisplayName, setShowInterfaceSettings = _a.setShowInterfaceSettings, setEmail = _a.setEmail, setId = _a.setId, setRole = _a.setRole, setMainCurrency = _a.setMainCurrency, setPermissions = _a.setPermissions;
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4 /*yield*/, client.query({
                        whoAmi: __assign(__assign({}, client.all), { permissions: true }),
                        initTranslations: client.all,
                    })];
            case 2:
                result = _e.sent();
                _b = result.whoAmi, photoURL = _b.photoURL, displayName = _b.displayName, showInterfaceSettings = _b.showInterfaceSettings, email = _b.email, id = _b.id, role = _b.role, mainCurrency = _b.mainCurrency, _c = _b.permissions, permissions = _c === void 0 ? [] : _c;
                loadI18n(result.initTranslations);
                if (id && email) {
                    setIsInitialized(true);
                    setIsAuthenticated(true);
                    setDisplayName(displayName);
                    setShowInterfaceSettings(showInterfaceSettings);
                    setEmail(email);
                    setRole(role);
                    setId(id);
                    setMainCurrency((_d = mainCurrency) !== null && _d !== void 0 ? _d : 'RUB');
                    if (setPermissions)
                        setPermissions(permissions !== null && permissions !== void 0 ? permissions : []);
                    if (photoURL)
                        setPhotoURL(photoURL);
                }
                else {
                    setIsInitialized(true);
                    setIsAuthenticated(false);
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _e.sent();
                setIsInitialized(true);
                setIsAuthenticated(false);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
/** Refresh-on-mount: relogin if refresh_token exists, then whoAmi. Ensures fresh permissions on app load. */
export var refreshSession = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, refreshToken, setAccessToken, setRefreshToken, _b, access_token, refresh_token, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = useStorage(STORAGE_NAME), refreshToken = _a.refreshToken, setAccessToken = _a.setAccessToken, setRefreshToken = _a.setRefreshToken;
                if (!refreshToken) return [3 /*break*/, 7];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 6, , 7]);
                return [4 /*yield*/, client.mutation({
                        relogin: __assign(__assign({}, client.all), { __args: { refresh_token: refreshToken } }),
                    })];
            case 2:
                _b = (_d.sent()).relogin, access_token = _b.access_token, refresh_token = _b.refresh_token;
                if (!(access_token && refresh_token)) return [3 /*break*/, 5];
                return [4 /*yield*/, setAccessToken(access_token)];
            case 3:
                _d.sent();
                return [4 /*yield*/, setRefreshToken(refresh_token)];
            case 4:
                _d.sent();
                broadcastTokensUpdated(access_token, refresh_token);
                _d.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                _c = _d.sent();
                return [3 /*break*/, 7];
            case 7: return [4 /*yield*/, whoAmi()];
            case 8:
                _d.sent();
                return [2 /*return*/];
        }
    });
}); });
export var login = createAction(function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, setIsAuthenticated, setLoginError, setAccessToken, setRefreshToken, setIsInitialized, login_1, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = useStorage(STORAGE_NAME), setIsAuthenticated = _a.setIsAuthenticated, setLoginError = _a.setLoginError, setAccessToken = _a.setAccessToken, setRefreshToken = _a.setRefreshToken, setIsInitialized = _a.setIsInitialized;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, client.mutation({
                        login: __assign(__assign({}, client.all), { __args: { email: email, password: password } }),
                    })];
            case 2:
                login_1 = (_b.sent()).login;
                if (login_1.access_token && login_1.refresh_token) {
                    setAccessToken(login_1.access_token);
                    setRefreshToken(login_1.refresh_token);
                    setLoginError(false);
                    whoAmi();
                }
                else {
                    setIsInitialized(true);
                    setIsAuthenticated(false);
                    setAccessToken();
                    setRefreshToken();
                    setLoginError(true);
                }
                return [3 /*break*/, 4];
            case 3:
                error_2 = _b.sent();
                setIsInitialized(true);
                setIsAuthenticated(false);
                setLoginError(true);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var updateOneUser = createAction(function (formData) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, photoURL, setPhotoURL, setDisplayName, setShowInterfaceSettings, _b, newPhotoURL, displayName, showInterfaceSettings, id, email;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = useStorage(STORAGE_NAME), photoURL = _a.photoURL, setPhotoURL = _a.setPhotoURL, setDisplayName = _a.setDisplayName, setShowInterfaceSettings = _a.setShowInterfaceSettings;
                return [4 /*yield*/, client.mutation({ updateOneUser: __assign({ __args: formData }, client.all) })];
            case 1:
                _b = (_c.sent()).updateOneUser, newPhotoURL = _b.photoURL, displayName = _b.displayName, showInterfaceSettings = _b.showInterfaceSettings, id = _b.id, email = _b.email;
                if (id && email) {
                    setDisplayName(displayName);
                    setShowInterfaceSettings(showInterfaceSettings);
                    if (photoURL !== newPhotoURL) {
                        setPhotoURL(newPhotoURL);
                    }
                }
                return [2 /*return*/];
        }
    });
}); });
export var uploadUserAvatar = createAction(function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var setPhotoURL, formData, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setPhotoURL = useStorage(STORAGE_NAME).setPhotoURL;
                formData = new FormData();
                formData.append('file', file, (file === null || file === void 0 ? void 0 : file.name) || 'avatar.jpg');
                return [4 /*yield*/, restQuery.uploads.avatar.post({
                        data: formData,
                    })];
            case 1:
                result = _a.sent();
                if (result === null || result === void 0 ? void 0 : result.url) {
                    setPhotoURL(result.url);
                }
                return [2 /*return*/];
        }
    });
}); });
export var logout = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, client.mutation({ logOut: true })];
            case 1:
                result = (_a.sent()).logOut;
                if (result) {
                    purge();
                }
                return [2 /*return*/];
        }
    });
}); }, { setIsPendingTo: STORAGE_NAME });
export var loadSessions = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
    var setSessions, sessions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setSessions = useStorage(STORAGE_NAME).setSessions;
                return [4 /*yield*/, client.query({ listSessions: client.all })];
            case 1:
                sessions = (_a.sent()).listSessions;
                setSessions(sessions);
                return [2 /*return*/];
        }
    });
}); });
export var deleteSession = createAction(function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var setSessions, sessions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setSessions = useStorage(STORAGE_NAME).setSessions;
                return [4 /*yield*/, client.mutation({ deleteSession: __assign(__assign({}, client.all), { __args: { id: Number(id) } }) })];
            case 1:
                sessions = (_a.sent()).deleteSession;
                if (sessions && isArray(sessions)) {
                    setSessions(sessions);
                }
                return [2 /*return*/];
        }
    });
}); });
export var loadLoginHistory = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
    var setLoginHistory, loginHistory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setLoginHistory = useStorage(STORAGE_NAME).setLoginHistory;
                return [4 /*yield*/, client.query({ loginHistory: client.all })];
            case 1:
                loginHistory = (_a.sent()).loginHistory;
                setLoginHistory(loginHistory);
                return [2 /*return*/];
        }
    });
}); });
export var changePassword = createAction(function (formData) { return __awaiter(void 0, void 0, void 0, function () {
    var setIsInitialized, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setIsInitialized = useStorage(STORAGE_NAME).setIsInitialized;
                return [4 /*yield*/, client.mutation({
                        changePassword: {
                            __args: formData,
                        },
                    })];
            case 1:
                result = (_a.sent()).changePassword;
                if (result) {
                    purge();
                    setIsInitialized(true);
                }
                return [2 /*return*/, result];
        }
    });
}); });
